<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10" :without-margin="withoutMargin">
		<h3 v-if="title" class="text-lg md:text-xl font-medium">{{ title }}</h3>
		<div v-if="copy" class="content-rte mt-3 md:mt-6" v-html="copy"></div>
	</DjBox>
</template>

<script lang="ts">
import DjBox from "./DjBox.vue";

import { defineComponent } from "vue";

export default defineComponent({
	name: "DjBoxRte",
	components: {
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: false,
		},
		copy: {
			type: String,
			default: "",
			required: false,
		},
		withoutMargin: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
